import React, { useState } from "react";
import { Button, Tooltip, Drawer, List, Typography } from "antd";
import { FileExcelOutlined, BarsOutlined } from "@ant-design/icons";
import TablaNovedades from "../Novedades/TablaNovedades";
import Participantes from "./Participants";
import Header166 from "../header/header";
import TablaVisitaTecnica from "../Visitas/VisitaTecnica/TablaVisitaTecnica";
import ExportInformeGeneral from "../Visitas/informe/Exportable_informacionGeneral";
import Export_diagnostico_parte1 from "../Visitas/Diagnostico/exportable/diagnostico_parte1_excel";
import Export_analisisCapacidades from "../Visitas/AnalisisCapacidades/exportable/analisis_capaciaddes_excel";
import Export_autorizacion_imagen from "../Visitas/Autorizacion_imagen/exportable.jsx/autorizacion_imagen_excel";
import { useSelector } from "react-redux";
import { selectAppPermissions } from "../../store/auth/selectors";
import Export_medicionCapacidadSalida from "../Visitas/medicionCapacidadesSalida/exportable/medicion_capacidades_salida_excel";
import Export_ComparativoAnalisisMedicion from "../Visitas/informe/informeComparativoAnalisisMedicionExcel";

const { Title } = Typography;

const RenderizarComponenteParticipantes = () => {
  const [showNovedades, setShowNovedades] = useState(false);
  const [selectedButton, setSelectedButton] = useState("participantes");
  const [showVisitaTecnica, setShowVisitaTecnica] = useState(false);
  const [titleHeader, setTitleHeader] = useState("pr");
  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleNavigation = (newSection) => {
    setTitleHeader(newSection);
  };

  const usePermission = (appName) => {
    const permissions = useSelector((state) =>
      selectAppPermissions(state, appName)
    );
    return permissions?.priv_access === "Y";
  };

  // --- Uso
  const permissionAccesoParticipantes = usePermission("participantes-paati");
  const permissionAccesoNovedades = usePermission("novedades");
  const permissionAccesoVisitaTecnica = usePermission("visitas");
   const permissionAccesoInformesPaati = usePermission("informes_paati_export");

  // Lista de informes con sus respectivos componentes
  const informes = [
    { titulo: "Informe General", componente: <ExportInformeGeneral /> },
    { titulo: "Diagnóstico", componente: <Export_diagnostico_parte1 /> },
    {
      titulo: "Análisis de Capacidades",
      componente: <Export_analisisCapacidades />,
    },

    {
      titulo: "Autorizacón de imagen",
      componente: <Export_autorizacion_imagen />,
    },
    {
      titulo: "Medición de capacidades de salida",
      componente: <Export_medicionCapacidadSalida />,
    },

       {
      titulo: "Comparativo analísis y medición",
      componente: <Export_ComparativoAnalisisMedicion />,
    },
  ];

  return (
    <div className="participants-component container">
      <div className="row mb-2 d-flex align-items-center">
        <Header166 type={titleHeader} />
        <div className="col-md-4 d-flex justify-content-center align-items-center flex-column">
          <h2 className="text-center mb-2">UTF COL 166 COL</h2>

          <div className="row mb-4">
            <div className="col-md-12 mt-2">
              <div className="d-flex justify-content-end mt-2">
                {permissionAccesoParticipantes && (
                  <Tooltip title="Participantes">
                    <Button
                      type={
                        selectedButton === "participantes"
                          ? "primary"
                          : "default"
                      }
                      className="me-2"
                      size="large"
                      onClick={() => {
                        setShowNovedades(false);
                        setShowVisitaTecnica(false);
                        setSelectedButton("participantes");
                        handleNavigation("pr");
                      }}
                    >
                      Participantes
                    </Button>
                  </Tooltip>
                )}

                {permissionAccesoNovedades && (
                  <Tooltip title="Novedades">
                    <Button
                      type={
                        selectedButton === "novedades" ? "primary" : "default"
                      }
                      className="me-2"
                      size="large"
                      onClick={() => {
                        setShowNovedades(true);
                        setShowVisitaTecnica(false);
                        setSelectedButton("novedades");
                        handleNavigation("n");
                      }}
                    >
                      Novedades
                    </Button>
                  </Tooltip>
                )}

                {permissionAccesoVisitaTecnica && (
                  <Tooltip title="Visita técnica">
                    <Button
                      type={
                        selectedButton === "visitaTecnica"
                          ? "primary"
                          : "default"
                      }
                      className="me-2"
                      size="large"
                      onClick={() => {
                        setShowNovedades(false);
                        setShowVisitaTecnica(true);
                        setSelectedButton("visitaTecnica");
                        handleNavigation("vt");
                      }}
                    >
                      Visita técnica
                    </Button>
                  </Tooltip>
                )}

                {/* Mostrar botón de Informes solo si "Participantes" está seleccionado */}
                {selectedButton === "participantes" &&  permissionAccesoInformesPaati && (
                  <Tooltip title="Informes">
                    <Button
                      type="primary"
                      icon={<BarsOutlined />}
                      className="me-2"
                      size="large"
                      onClick={() => setDrawerVisible(true)}
                    >
                      Informes
                    </Button>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contenido principal dinámico */}
      {showNovedades ? (
        <TablaNovedades />
      ) : showVisitaTecnica ? (
        <TablaVisitaTecnica />
      ) : (
        <Participantes />
      )}

      {/* Drawer para mostrar la lista de informes */}
      <Drawer
        title="Informes Disponibles"
        placement="right"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
      >
        <List
          dataSource={informes}
          renderItem={(item) => (
            <List.Item
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Title level={5} style={{ margin: 0 }}>
                {item.titulo}
              </Title>
              {item.componente}
            </List.Item>
          )}
        />
      </Drawer>
    </div>
  );
};

export default RenderizarComponenteParticipantes;
